import ActualBoatSearch from "./ActualBoats/ActualBoatSearch";
import BoatTypeSearch from "./BoatTypes/BoatTypeSearch";
import CssBaseline from "@mui/material/CssBaseline";
import React from "react";
import chroma from "chroma-js";
import { AnimatePresence } from "motion/react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { DesktopLayout } from "@ntg/component-library/app";
import { DrawerContents } from "./DrawerContents";
import { LayoutContextProvider, UserContextProvider } from "@ntg/component-library/contexts";
import { ThemeProvider } from "@mui/material/styles";
import { createCSDarkTheme, createCSTheme } from "@ntg/component-library/theming";
import { useValidate } from "@ntg/component-library/contexts";

export default function App2() {
    const { isLoading, error } = useValidate();

    if (isLoading) return "Authenticating...";
    if (error) return "An error has occurred: " + error.message;

   // const isDarkMode: boolean = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
    const isDarkMode: boolean = true;
    const menuBar = "#0047AB";
    const secondaryMenuBar = "#14364eff";

    const primary = "#145685ff";
    const secondary = "#14918aff";
    const tertiary = "#044714ff";
    const quaternary = "#411570ff";
    const background = "#000000ff";

    const indicator = "#e6d887ff";

    let theme;
    if (isDarkMode) {
        theme = createCSDarkTheme({
            background: background,
            backgroundPaper: chroma(background).brighten(0.2).hex(),
            menuBar: menuBar,
            secondaryMenuBar: secondaryMenuBar,

            indicator: indicator,
            primary: primary,
            secondary: secondary,
            tertiary: tertiary,
            quaternary: quaternary,
        });
    } else {
        theme = createCSTheme({
            background: background,
            backgroundPaper: chroma(background).brighten(0.2).hex(),
            menuBar: menuBar,
            secondaryMenuBar: secondaryMenuBar,

            indicator: indicator,
            primary: primary,
            secondary: secondary,
            tertiary: tertiary,
            quaternary: quaternary,
        });
    }



    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <UserContextProvider>
                <BrowserRouter>
                    <LayoutContextProvider
                        DrawerContents={DrawerContents}
                        ModuleName="Boats"
                        ModuleTitle="Boats"
                    >
                        <DesktopLayout
                            MainContent={
                                <AnimatePresence mode="wait">
                                    <Routes>
                                        <Route element={<BoatTypeSearch />} path="/" />
                                        <Route element={<BoatTypeSearch />} path="/boatTypeSearch" />
                                        <Route element={<ActualBoatSearch />} path="/actualBoatSearch" />
                                    </Routes>
                                </AnimatePresence>
                            }
                            TerminalContent={<div>terminal</div>}
                        />
                    </LayoutContextProvider>
                </BrowserRouter>
            </UserContextProvider>
        </ThemeProvider>
    );
}
